export var GUTTER_SIZE_IN_PX = 120; // Default gutter size
export var GUTTER_SIZE_MOBILE_IN_PX = 36; // Gutter size for Mobile
export var GUTTER_SELECTOR = '#editor-scroll-gutter';